/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ValidationAccountStatus;

(function (ValidationAccountStatus) {
  ValidationAccountStatus["ACTIVE"] = "active";
  ValidationAccountStatus["REACTIVATED"] = "reactivated";
  ValidationAccountStatus["DEACTIVATED"] = "deactivated";
})(ValidationAccountStatus || (ValidationAccountStatus = {}));